/*
 * useTreeState  hook
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { useCallback, useState } from "react";
import { ITreeState } from "./TreeViewTypes";
import { ITreeViewProps } from "./TreeView";

export function useTreeState(
	defaultState: ITreeState = { nodes: {} }
): [ITreeState, ITreeViewProps["onStateUpdate"]] {
	const [ treeState, setTreeState ] = useState<ITreeState>(defaultState);
	const treeStateUpdateHandler = useCallback<ITreeViewProps["onStateUpdate"]>(
		(state) => {
			setTreeState({ ...state });
		},
		[ setTreeState ]
	);

	return [ treeState, treeStateUpdateHandler ];
}
